
import {IGameRealityCheckInterval, IRegulation} from "./regulation.service.interface";
import {ILegacyRegulation} from "./legacy-regulation.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {REGULATION_NAMES} from "../../../sdk/src/services/regulation/regulation_const";
import {NullableString} from "../../../common/types/nullable-types";
import {NAVIGATION_VIEWS} from "../../../sdk/src/components/external_links/external_links_consts";
import {
    IExternalLinksHandlersFactory
} from "../external-links/handlers-factory/external-links-handlers-factory.interface";
import {ExternalLinksHandlersFactory} from "../external-links/handlers-factory/external-links-handlers-factory";

export class LegacyRegulationWrapper implements IRegulation {
    constructor(protected readonly legacyRegulation: ILegacyRegulation,
        public readonly regulationType: number,
        protected services: IServiceFactoryExtended) {
    }
    get name(): string {
        return REGULATION_NAMES[this.regulationType];
    }

    get responsibleGamingAge(): number {
        return this.services.sdk.getSkin().getMinimumAge();
    }

    getRealityCheckIntervalExpectedByTheGame(): IGameRealityCheckInterval {
        return this.legacyRegulation.getRealityCheckIntervalExpectedByTheGame();
    }

    getAgeResponsibleGamingLabel(): NullableString {
        return this.legacyRegulation.getAgeResponsibleGamingLabel();
    }

    async disableRealityCheck(): Promise<void> {
        await this.legacyRegulation.updateRealityCheckInterval(0);
    }

    showNightLimitMessage(nightLimitExpirationDate: Date) {
        this.legacyRegulation.showNightLimitMessage(nightLimitExpirationDate);
    }

    get postLoginActionsArePassed(): boolean {
        return this.legacyRegulation.postLoginActionsArePassed();
    }

    openSelfExclusion(): void {
        this.legacyRegulation.openSelfExclusion(NAVIGATION_VIEWS.WINDOW);
    }

    openSelfTest(): void {
        this.legacyRegulation.openSelfTest(NAVIGATION_VIEWS.WINDOW)
    }

    logoutUser(): Promise<void> {
        return this.services.user.logout();
    }

    get externalLinks(): IExternalLinksHandlersFactory {
        return new ExternalLinksHandlersFactory(this.services);
    }
}